import {ReactElement} from 'react'
import {Button} from '@material-ui/core'
import {Trans} from 'react-i18next'
import {useHistory} from 'react-router-dom'

import {ModalContainer} from '../ModalContainer'
import messages from '../../../../../assets/messages'
import {useStyles} from './styles'

const none = () => null

const SUPPORT_EMAIL = 'support@tauromarkets.com'

type DepositMethodVerificationSubmittedModalProps = {
  isOpen: boolean,
}

function DepositMethodVerificationSubmittedModal(props: DepositMethodVerificationSubmittedModalProps): ReactElement {
  const classes = useStyles()
  const history = useHistory()
  const {isOpen} = props

  const handleGoToAccountsClick = () => history.push('/')

  return (
    <ModalContainer isOpen={isOpen} onClose={none}>
      <div className={classes.content}>
        <div className={classes.header}>
          <div className={classes.title}>
            <Trans {...messages.yourRequestHasBeenSubmitted} />
          </div>
          <div className={classes.subtitle}>
            <Trans {...messages.weReceivedYourRequest} />
          </div>
        </div>
        <div className={classes.body}>
          <div className={classes.bodyTitle}>
            <Trans {...messages.whatHappensNext} />
          </div>
          <ul className={classes.bodyList}>
            <li>
              <Trans
                {...messages.ourTeamWillReviewYourDocuments}
                components={[<b>ourTeamWillReviewYourDocuments</b>]}
              />
            </li>
            <li>
              <Trans
                {...messages.youWillReceiveAnUpdateViaEmailOrCall}
                components={[<b>youWillReceiveAnUpdateViaEmailOrCall</b>]}
              />
            </li>
            <li>
              <Trans {...messages.ifWeNeedAnyFurtherDetails} />
            </li>
          </ul>
          <div>
            <Trans
              {...messages.ifYouHaveUrgentQuestions}
              values={{supportEmail: SUPPORT_EMAIL}}
              components={[<a className={classes.link} href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>]}
            />
          </div>
          <Button className={classes.button} fullWidth color='primary' variant='contained' onClick={handleGoToAccountsClick}>
            <Trans {...messages.goBackToAccounts} />
          </Button>
        </div>
      </div>
    </ModalContainer>
  )
}

export {DepositMethodVerificationSubmittedModal}
